import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "textDv" }
const _hoisted_2 = {
  key: 1,
  class: "middleDv"
}
const _hoisted_3 = { class: "endDv" }
const _hoisted_4 = { class: "lastDv" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_StockImageTag = _resolveComponent("StockImageTag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SparklineComponent = _resolveComponent("SparklineComponent")!

  return (_ctx.stock && _ctx.trade)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["itemStockinfoWatchlistDv", { fluidWrapper: _ctx.isFluid }])
      }, [
        (_ctx.showRemove)
          ? (_openBlock(), _createBlock(_component_IconComponent, {
              key: 0,
              class: _normalizeClass(["iconDv", { removeOnRightCenter: _ctx.staticRemove }]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onRemove()), ["stop"])),
              onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRemove())),
              id: `minusWining${_ctx.index}`,
              icon: "minus.svg"
            }, null, 8, ["class", "id"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["firstDv", { noChartItem: !_ctx.showChart }])
        }, [
          (_openBlock(), _createBlock(_component_StockImageTag, {
            stockId: _ctx.trade.stockId || _ctx.trade._id,
            imgUrl: _ctx.stock.logoUrl,
            symbol: _ctx.stock.symbol,
            market: _ctx.trade.market || _ctx.trade.type || 'stocks',
            key: _ctx.trade.stockId
          }, null, 8, ["stockId", "imgUrl", "symbol", "market"])),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.stock?.symbol ?? "-"), 1),
            (_ctx.shouldShowTooltip)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "dark",
                  content: _ctx.stock.name,
                  placement: "top-start"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      ref: "textElement",
                      class: "no-rtl",
                      onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkOverflow && _ctx.checkOverflow(...args)))
                    }, _toDisplayString(_ctx.stock.name ?? "-"), 545)
                  ]),
                  _: 1
                }, 8, ["content"]))
              : (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  ref: "textElement",
                  class: "no-rtl",
                  onMouseover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkOverflow && _ctx.checkOverflow(...args)))
                }, _toDisplayString(_ctx.stock.name ?? "-"), 545))
          ])
        ], 2),
        (_ctx.showChart)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(), _createBlock(_component_SparklineComponent, {
                key: _ctx.stock?._id + _ctx.stock?.changesPercentage,
                isPositive: _ctx.stock?.changesPercentage >= 0,
                data: _ctx.stock?.fiveDayTrend
              }, null, 8, ["isPositive", "data"]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock("h2", {
              key: _ctx.stock?._id + _ctx.stock?.price,
              ref: "priceElement",
              innerHTML: 
            _ctx.$filters.systemNumberConvention(
              _ctx.stock?.price,
              true,
              false,
              _ctx.widthCalculating
            )
          
            }, null, 8, _hoisted_5)),
            _createElementVNode("div", {
              class: _normalizeClass([{ downward: _ctx.stock?.changesPercentage < 0 }, "informationGridWatchlistViewDv"])
            }, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: '$' + _ctx.stock.change,
                placement: "top-start"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_IconComponent, {
                      class: "priceIcon",
                      icon: "stock-pricing-up-icon.svg"
                    }),
                    _createTextVNode(" " + _toDisplayString(Math.abs(
                  _ctx.$filters.systemNumberConvention(
                    _ctx.stock.changesPercentage,
                    false
                  )
                )) + "% ", 1)
                  ])
                ]),
                _: 1
              }, 8, ["content"])
            ], 2)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}